import React from 'react';
import AlephLogo from 'js/reusable/Logo/AlephLogo/container';
import classNames from 'classnames';
import MetaLogo from 'js/reusable/Logo/MetaLogo/container';
import {setTestId} from 'js/reusable/testing/setTestId';
import {LogoProps} from 'js/reusable/Logo/AlephLogo/container';

interface IProps extends LogoProps {
    showMetaLogo?: boolean;
    metaLogoSimplified?: boolean;
}

function Logo({className, showMetaLogo = false, metaLogoSimplified = false, light = false, colored = false}: IProps) {
	const cssClassnames: string = classNames(
		'tw-flex tw-text-center tw-w-fit',
		className,
		{'tw-flex-wrap tw-justify-center': metaLogoSimplified}
	);

	const alephCssClasnames: string = classNames(
		{
			'tw-border-white/25':                          showMetaLogo && !metaLogoSimplified && light,
			'tw-border-black/25':                          showMetaLogo && !metaLogoSimplified && !light,
			'tw-pr-5 tw-mr-5 tw-border-r tw-border-solid': showMetaLogo && !metaLogoSimplified,
			'tw-w-3/5':                                    metaLogoSimplified,
		}
	);

	return (
		<div
			className={cssClassnames}
			data-testid={setTestId('logo')}
		>
			<AlephLogo
				className={alephCssClasnames}
				light={light}
				colored={colored}
			/>

			{showMetaLogo && <MetaLogo simple={metaLogoSimplified} />}
		</div>
	);
}

export default Logo;
